export default [
    {
      movieImage: "./movie-images/redemption.jpg",
      movieName: "The Shawshank Redemption",
      yearOfRelease: 1994,
      duration: "142 min"
    },
    {
      movieImage: "./movie-images/matrix.jpg",
      movieName: "The Godfather Part II",
      yearOfRelease: 1974,
      duration: "202 min"
    },
    {
      movieImage: "./movie-images/darkknight.jpg",
      movieName: "The Dark Knight",
      yearOfRelease: 2008,
      duration: "152 min"
    },
    {
      movieImage: "./movie-images/schindlerslist.jpg",
      movieName: "Pulp Fiction",
      yearOfRelease: 1994,
      duration: "154 min"
    },
    {
      movieImage:"./movie-images/12angrymen.jpg",
      movieName: "12 Angry Men",
      yearOfRelease: 1957,
      duration: "96 min"
    },
    {
      movieImage:"./movie-images/redemption.jpg ",
      movieName: "The Lord of the Rings: The Return of the King",
      yearOfRelease: 2003,
      duration: "201 min"
    },
    {
      movieImage:"./movie-images/schindlerslist.jpg",
      movieName: "Schindler's List",
      yearOfRelease: 1993,
      duration: "195 min"
    },
    {
      movieImage:"./movie-images/12angrymen.jpg",
      movieName: "The Silence of the Lambs",
      yearOfRelease: 1991,
      duration: "118 min"
    },
    {
      movieImage: "./movie-images/matrix.jpg",
      movieName: "The Matrix",
      yearOfRelease: 1999,
      duration: "136 min"
    },
    {
      movieImage: "./movie-images/schindlerslist.jpg",
      movieName: "Inception",
      yearOfRelease: 2010,
      duration: "148 min"
    },
    {
      movieImage: "./movie-images/darkknight.jpg",
      movieName: "The Dark Knight",
      yearOfRelease: 2008,
      duration: "152 min"
    },
    {
      movieImage: "./movie-images/redemption.jpg",
      movieName: "Pulp Fiction",
      yearOfRelease: 1994,
      duration: "154 min"
    },
    {
      movieImage: "./movie-images/matrix.jpg",
      movieName: "The Godfather Part II",
      yearOfRelease: 1974,
      duration: "202 min"
    },
    {
      movieImage:"./movie-images/darkknight.jpg",
      movieName: "The Silence of the Lambs",
      yearOfRelease: 1991,
      duration: "118 min"
    }

  ];
  